module.exports = __webpack_public_path__ + "media/bookPage/1-29cffd9b.jpeg";